module.exports = __webpack_public_path__ + "8760e2560babf5e7ab176e5503f5b205.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/settings_folder_2x.png
// module id = 140
// module chunks = 0 1 2 3 4